export var dayOfMonth = "do";
export var longLocalised = "P" // 05/29/1453
;
export var fullMonthYear = "MMMM y";
